/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg id="Group_3192" data-name="Group 3192" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <rect id="Rectangle_777" data-name="Rectangle 777" fill="none"/>
  <path id="Path_1954" data-name="Path 1954" d="M16.915,0H0" transform="translate(3.808 11.784)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.4"/>
  <path id="Path_1886" data-name="Path 1886" d="M11.78,3.812,3.808,11.785l7.972,7.971" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"/>
</svg>
`

const BackArrowSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default BackArrowSvg
